import React from 'react';

import {
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TextField
} from '@material-ui/core';

import {
    BodyTableCell,
    ContainerDiv,
    FlexSpaceBetweenDiv,
    HeaderTableCell,
    OverflowXDiv,
    PrimaryButton
} from '../components/components';

import { TableFooterWithPaginator } from '../components/tableFooterWithPaginator';
import { SortHeaderCell } from '../components/sortHeaderCell';
import SearchIcon from '../equipment/images/search_list_ico.png';
import { withSnackbar } from 'notistack';
import { CategoryService } from './categoryService';
import { CategoryDialogButton } from './categoryDialogButton';
import { CollectionViewUpdater } from '../utils/collectionViewUpdater';

import Spinner from 'react-spinner-material'
import { StringService } from '../utils/stringService';
import { PageWrap, Card, CardHead, CardBody, PageBanner, CountBadge } from '../components/pageLayout';
import { Layers } from 'lucide-react';

class CategoriesPage extends React.Component {
    constructor (props) {
        super(props)

        this.collectionUpdater = CollectionViewUpdater.ofCategories(this)

        this.state = {
            isLoading: false,
            companyData: {id: null, name: ''},
            filterQuery: '',
            filterEnabled: '',
            collection: this.collectionUpdater.collection
        }
    }

    componentDidMount () {
        this.setState({isLoading: true})

        CategoryService.list().then(items => {
            this.collectionUpdater.initialData(items)
            this.setState({isLoading: false})
        })
    }

    notify = message => () => this.props.enqueueSnackbar(message)

    handleCreateSubmit = (categoryData, inspectionAttributes, maintenanceAttributes) => CategoryService.create(categoryData, inspectionAttributes, maintenanceAttributes)
        .then(this.collectionUpdater.createItem)
        .then(this.notify(StringService.formatTextVariable(this.props.currentLanguage.created_category, categoryData.name)))
    handleUpdateSubmit = (categoryId, categoryData, inspectionAttributes, maintenanceAttributes) => CategoryService.update(categoryId, categoryData, inspectionAttributes, maintenanceAttributes)
        .then(this.collectionUpdater.updateItem)
        .then(this.notify(StringService.formatTextVariable(this.props.currentLanguage.updated_category, categoryData.name)))

    buildList = () => {
        const { isLoading, collection } = this.state
        const { currentLanguage } = this.props

        if (isLoading) {
            return (
                <TableRow> 
                    <BodyTableCell colSpan={3}><div style={{position:'relative', top:'45%', left:'45%'}}> <Spinner  size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} /> </div></BodyTableCell>
                </TableRow>
            )
        }

        const items = collection.paginator.pagedItems

        if (items.length === 0) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={3}>{currentLanguage.empty_list}</BodyTableCell>
                </TableRow>
            )
        }

        return items.map(category => (
            <TableRow key={category.id}>
                <BodyTableCell>{category.name}</BodyTableCell>
                <BodyTableCell>{category.enabled ? currentLanguage.yes : currentLanguage.no}</BodyTableCell>
                <BodyTableCell align="center">
                    <CategoryDialogButton
                        currentLanguage={currentLanguage}
                        submitLabel={currentLanguage.update_category}
                        categoryId={category.id}
                        categoryData={{ name: category.name, enabled: category.enabled }}
                        onSubmit={(categoryData, inspectionAttributes, maintenanceAttributes) => this.handleUpdateSubmit(category.id, categoryData, inspectionAttributes, maintenanceAttributes)}
                        ModalButton={({onClick}) => (
                            <IconButton onClick={onClick}><img src={SearchIcon} alt="search" /></IconButton>
                        )}
                    />
                </BodyTableCell>
            </TableRow>
        ))
    }

    render () {
        const { collection, filterQuery, filterEnabled } = this.state
        const { currentLanguage } = this.props
        const { updateCollection, handleFilterChange, handleSort } = this.collectionUpdater
        const pageItems = collection.paginator.pagedItems

        const fieldLabelStyle = { fontSize: '0.75rem', fontWeight: 600, color: '#334155', marginBottom: 4 };

        return (
            <PageWrap>
                <PageBanner
                    icon={Layers}
                    title={currentLanguage.categories}
                    right={
                        <CategoryDialogButton
                            currentLanguage={currentLanguage}
                            submitLabel={currentLanguage.add_category}
                            categoryId={null}
                            categoryData={{ name: '', enabled: false }}
                            onSubmit={(categoryData, inspectionAttributes, maintenanceAttributes) => this.handleCreateSubmit(categoryData, inspectionAttributes, maintenanceAttributes)}
                            ModalButton={({onClick}) => (
                                <PrimaryButton onClick={onClick} style={{alignSelf: 'center'}}>{currentLanguage.add_category}</PrimaryButton>
                            )} />
                    }
                />

                <Card>
                    <CardHead>Filtros</CardHead>
                    <CardBody>
                    {/* Buscar */}
                    <div style={{ marginBottom: 16 }}>
                        <div style={fieldLabelStyle}>{currentLanguage.search}</div>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            helperText={currentLanguage.name}
                            value={filterQuery}
                            onChange={event => handleFilterChange({ filterQuery: event.target.value })}
                        />
                    </div>

                    {/* Dropdowns */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                        <div>
                            <div style={fieldLabelStyle}>{currentLanguage.able}</div>
                            <FormControl fullWidth margin="dense">
                                <Select variant="outlined" displayEmpty value={filterEnabled} onChange={event => handleFilterChange({ filterEnabled: event.target.value })} inputProps={{ id: 'enabled-select' }}>
                                    <MenuItem value="">Selecione uma opção</MenuItem>
                                    <MenuItem value="true">{currentLanguage.yes}</MenuItem>
                                    <MenuItem value="false">{currentLanguage.no}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    </CardBody>
                </Card>

                <Card>
                    <CardHead>{currentLanguage.categories} <CountBadge>{pageItems.length}</CountBadge></CardHead>
                    <OverflowXDiv>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} field="name">{currentLanguage.name}</SortHeaderCell>
                                <SortHeaderCell sorter={collection.sorter} onSort={handleSort} field="enabled" align="center">{currentLanguage.able}</SortHeaderCell>
                                <HeaderTableCell/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.buildList()}
                        </TableBody>
                        <TableFooterWithPaginator collection={collection} onCollectionUpdate={updateCollection} colSpan={3} />
                    </Table>
                    </OverflowXDiv>
                </Card>
            </PageWrap>
        )
    }
}

export default withSnackbar(CategoriesPage)
